import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../services/api.service';
import { AuthService } from '../services/auth.service';

@Component({
  standalone: true,
  selector: 'app-login',
  imports: [CommonModule, FormsModule],
  template: `
<div class="row justify-content-center">
  <div class="col-12 col-md-6">
    <h4>Login</h4>
    <form (ngSubmit)="doLogin()">
      <div class="mb-2">
        <label class="form-label">E-Mail</label>
        <input class="form-control" [(ngModel)]="email" name="email" required type="email">
      </div>
      <div class="mb-2">
        <label class="form-label">Passwort</label>
        <input class="form-control" [(ngModel)]="password" name="password" required type="password">
      </div>
      <div class="d-flex gap-2">
        <button class="btn btn-primary" type="submit">Login</button>
        <button class="btn btn-outline-secondary" type="button" (click)="doSignup()">Registrieren</button>
      </div>
      <div class="text-danger mt-2" *ngIf="error">{{ error }}</div>
    </form>

    <div class="mt-4" *ngIf="needsConfirm">
      <h5>Bestätigungscode eingeben</h5>
      <input class="form-control mb-2" [(ngModel)]="code" placeholder="Code">
      <button class="btn btn-success" (click)="doConfirm()">Bestätigen</button>
    </div>
  </div>
</div>
  `
})
export class LoginComponent {
  email = '';
  password = '';
  code = '';
  error = '';
  needsConfirm = false;

  constructor(private auth: AuthService, private api: ApiService, private router: Router) {}

  async doLogin() {
    try {
      this.error = '';
      await this.auth.signIn(this.email, this.password);
      this.router.navigateByUrl('/');
    } catch (e: any) {
      const msg = e?.message || '';
      // Falls bereits eingeloggt, trotzdem weiterleiten
      if (/already\s*signed\s*in/i.test(msg) || /already\s*authenticated/i.test(msg)) {
        this.router.navigateByUrl('/');
        return;
      }
      this.error = msg || 'Login fehlgeschlagen';
    }
  }

  async doSignup() {
    try {
      this.error = '';
      await this.auth.signUp(this.email, this.password);
      this.needsConfirm = true;
    } catch (e: any) {
      this.error = e?.message || 'Registrierung fehlgeschlagen';
    }
  }

  async doConfirm() {
    try {
      this.error = '';
      await this.auth.confirm(this.email, this.code);
      // Nach erfolgreicher Bestätigung einmalig anmelden und anonyme Bewertungen verknüpfen
      await this.auth.signIn(this.email, this.password);
      await this.api.linkAnonymous().catch(() => {});
      this.router.navigateByUrl('/');
    } catch (e: any) {
      this.error = e?.message || 'Bestätigung fehlgeschlagen';
    }
  }
}
